import Component from 'flarum/common/Component';
import IndexDisscussionWidget from './IndexDisscussionWidget';

/**
 * 首页热门显示
 */
export default class IndexWidget extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.black1Title = app.forum.attribute('widget_black1_title');
    this.black1Slug = app.forum.attribute('widget_black1_slug');
    this.black1Limit = app.forum.attribute('widget_black1_limit');
    this.black2Title = app.forum.attribute('widget_black2_title');
    this.black2Slug = app.forum.attribute('widget_black2_slug');
    this.black2Limit = app.forum.attribute('widget_black2_limit');

    this.sectionDiscussion = [
      {title: this.black1Title, slug: this.black1Slug, discussion: [], loading: false},
      {title: this.black2Title, slug: this.black2Slug, discussion: [], loading: false},
    ];
  }

  oncreate(vnode) {
    const tags = [
      {slug: this.black1Slug, limit: this.black1Limit || 5},
      {slug: this.black2Slug, limit: this.black2Limit || 5}
    ];

    tags.filter(tag => tag.slug)?.map((tag) => {
      const section = this.sectionDiscussion.find(section => section.slug === tag.slug);
      if (section) {
        section.loading = true;
      }
      app.store
        .find('discussions', {
          sort: '-view_count',
          filter: { tag: tag.slug },
          page: { limit: tag.limit },
        })
        .then((results) => {
          if (section) {
            section.loading = false;
            section.discussion = results;
          }
          m.redraw();
        })
        .catch(() => {
          if (section) {
            section.loading = false;
          }
        });
    });
  }

  view() {
    return (
      this.sectionDiscussion.map((section) => {
        const { title, discussion } = section;
        if (!section.slug) return;
        return (
          <IndexDisscussionWidget
            loading={section.loading}
            title={title}
            discussion={discussion}
          />
        );
      })
    );
  }
}
